module.exports = __webpack_public_path__ + "static/media/bfile-rv.cdfb3770.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-rv.svg
// module id = 170
// module chunks = 0